import type { AnyRouter } from '@tanstack/react-router';

/**
 * Dependency-free holder for the app's TanStack Router instance.
 *
 * Non-React callers (legacy window globals like `routeToMFE`, the header
 * bridge, the MFE loader) need to drive navigation, but they can't use the
 * `useRouter()` hook. They also can't import `router.tsx` directly without
 * creating an import cycle (`router.tsx` → `legacy-route-adapter`
 * → `router.tsx`). This tiny holder breaks that cycle: `router.tsx` registers
 * the instance at module load, and the adapters read it back.
 *
 * Driving navigation through `router.history.push()` (TanStack's own history)
 * guarantees the router reacts — a raw `window.history.pushState` +
 * synthetic `popstate` is NOT reliably picked up by TanStack Router, which is
 * why URL changes were not re-rendering the matched route.
 */
let instance: AnyRouter | null = null;

export function setRouterInstance(router: AnyRouter): void {
  instance = router;
}

export function getRouterInstance(): AnyRouter | null {
  return instance;
}
